import { render } from "./HeelzContest.vue?vue&type=template&id=4dd8a346"
import script from "./HeelzContest.vue?vue&type=script&lang=js"
export * from "./HeelzContest.vue?vue&type=script&lang=js"

import exportComponent from "/Users/philippschurig/PhpstormProjects/plenty_analytics_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__